import { observer } from 'mobx-react';
import HorizontalScrollContainer from '../common/HorizontalScrollContainer';

const AgentDataTable = observer(({ columns = [], rows = [], className = '' }) => {
  // Calculate dynamic column widths based on content
  const calculateColumnWidth = (column, rows) => {
    if (column.width) return column.width; // Respect explicit width if provided

    const headerLength = (column.label || column.key).length;
    const maxContentLength = Math.max(
      headerLength,
      ...rows.map((row) => String(row[column.key] || '').length)
    );

    // Base width calculation: character count * 8px + padding
    return `${Math.max(80, Math.min(200, maxContentLength * 8 + 32))}px`;
  };

  if (!rows.length) {
    return (
      <div className={`agent-data-table empty ${className}`}>
        <span className="empty-message">No results found</span>
      </div>
    );
  }

  return (
    <HorizontalScrollContainer className={`agent-data-table ${className}`}>
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} style={{ width: calculateColumnWidth(column, rows) }}>
                {column.label || column.key}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.id || index} className="data-row">
              {columns.map((column) => (
                <td key={column.key} className="agent-table-cell">
                  {row[column.key] || '—'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </HorizontalScrollContainer>
  );
});

export default AgentDataTable;
